<template>
  <div
    id="app"
    class="l-background"
    oncontextmenu="return false"
    ondragstart="return false"
  >
    <router-view />
    <LFullScreen v-if="isShowFull"></LFullScreen>
  </div>
</template>
<script>
import version from "@/utils/version";
import LFullScreen from "@/components/l-full-screen";
export default {
  data() {
    return {
      isShowFull: true,
    };
  },
  mounted() {
    if (version.isIOS()) {
      this.isShowFull = false;
    }
  },
  components: {
    LFullScreen,
  },
};
</script>
<style lang="stylus">
html, body, #app
  margin 0
  padding 0
  width 100%
  height 100%
#app
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  height 100%;
  text-align center
  color #333
  overflow overlay
*
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
</style>
